import vmClient from 'app/services/vmClient';
import {
  IVocabListHeader,
  VocabListHeaderAttributes,
  IVocabListHeaderAssociations,
  VocabListHeaderAssociations,
} from 'app/constants/schemas/VocabListHeader';
import { IVocabListWord, VocabListWord } from 'app/constants/schemas/VocabListWord';
import { IVocabListSentence, VocabListSentence } from 'app/constants/schemas/VocabListSentence';
import { Entity, IEntityType } from 'app/types/entity';

interface IVocabListAssociations extends IVocabListHeaderAssociations {
  vocabListWords: IVocabListWord[];
  vocabListSentences: IVocabListSentence[];
}

export interface IVocabList extends IVocabListHeader {
  associations: IVocabListAssociations;
}

export type VocabList = Entity<IVocabList>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabList: IEntityType<IVocabList> = vmClient.defineClass({
  typeName: 'VocabList',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: VocabListHeaderAttributes,
  associations: {
    ...VocabListHeaderAssociations,
    vocabListWords: {
      type: VocabListWord,
      notNull: true,
      collection: true,
    },
    vocabListSentences: {
      type: VocabListSentence,
      notNull: true,
      collection: true,
    },
  },
});
